export default __webpack_public_path__ + "static/media/wa_2.bb0e238e.mp3";